import { useState } from "react";
import inputLockIcon from "../../assets/imgs/input-lock-icon.svg";
import inputGeoIcon from "../../assets/imgs/geo.svg";
import inputSuccessIcon from "../../assets/imgs/input-success-icon.svg";
import spinnerIcon from "../../assets/imgs/spinner.gif";
import closeIcon from "../../assets/imgs/close-icon.svg";
import "./style.css";

const states = {
    IDLE: 1,
    BUSY: 2,
    SUCCESS: 3,
    ERROR: 4,
};

export const TextInput = ({
    type = "text",
    value = "",
    name = "",
    active = false,
    isGeo = false,
    placeholder = "",
    readonly = false,
    state = states.IDLE,
    onChange = (evt) => {},
    onEnter = () => {},
    onBlur = (evt) => {},
    onIconClick = (evt) => {},
    classList = "",
    children,
    withEllipsis = true,
    minLength = 2,
    maxLength = 9999,
}) => {
    const [isActive, setIsActive] = useState(active);

    const _onChange = (evt) => {
        const value = evt.target.value;
        setIsActive(value.length > 0);
        onChange(value);
    };

    const getStateIcon = () => {
        return readonly
            ? inputLockIcon
            : isGeo && state == states.IDLE
            ? inputGeoIcon
            : state == states.SUCCESS
            ? inputSuccessIcon
            : state == states.BUSY
            ? spinnerIcon
            : state == states.ERROR
            ? closeIcon
            : "";
    };

    const _onBlur = (evt) => {
        evt.target.value.length && onBlur(evt.target.value);
    };

    const _onKeyDown = (evt) => {
        if (evt.key === "Enter") onEnter();
    };

    return (
        <div
            className={`text-input-component ${withEllipsis == true ? "ellipsis" : ""} ${type == "date" ? "force-floating-label" : ""} ${isActive || value !== "" ? "active" : ""} ${
                type == "hidden" ? "hidden" : ""
            } ${classList}`}>
            <input
                minLength={minLength}
                maxLength={maxLength}
                type={type}
                className={`text-md ${state == states.SUCCESS ? "ready" : state == states.ERROR ? "error" : ""} ${classList}`}
                name={name}
                id={`text-input-${name}`}
                value={value}
                readOnly={readonly}
                disabled={readonly}
                onChange={_onChange}
                onBlur={_onBlur}
                onKeyDown={_onKeyDown}
            />
            <label htmlFor={`text-input-${name}`}>{placeholder}</label>

            <img className={`state-icon ${readonly || isGeo || state != states.IDLE ? "showing" : ""} ${isGeo ? "clickable" : ""}`} src={getStateIcon()} onClick={onIconClick} />

            <div className={`text-error ${state == states.ERROR ? "showing" : ""}`}>Il valore inserito non è valido</div>

            {children}
        </div>
    );
};
